import { createQueryKeys } from "@lukemorales/query-key-factory";
import { skipToken } from "@tanstack/react-query";

import { recentPayments } from "./payments";

export const paymentsQueriesStore = createQueryKeys("payments", {
  recent: (userCode?: string) => ({
    queryKey: [userCode],
    queryFn: userCode ? () => recentPayments(userCode) : (skipToken as never),
  }),
});
